// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"128":"6fcc975839f53b033ce2","992":"a29ce42e938ed01bd2a9"}[chunkId] + ".chunk.js";
};